/*
 *
 * LanguageProvider reducer
 *
 */

import produce from 'immer';

import { DEFAULT_LOCALE } from './i18n';
import { CHANGE_LOCALE } from './actionTypes';

export const initialState = {
  locale: localStorage.language || DEFAULT_LOCALE,
};

/* eslint-disable default-case, no-param-reassign */
const languageProviderReducer = (state = initialState, action) =>
  produce(state, draft => {
    switch (action.type) {
      case CHANGE_LOCALE:
        draft.locale = action.locale;
        localStorage.language = action.locale;
        break;
    }
  });

export default languageProviderReducer;
